export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Project-Portfolio-960.6819f75a.webp";